<div>
    <div class="table-responsive" >
        <div [innerHTML]="infoProject?.newProject?.sectionOpInvest?.descriptionPerformance | safeHtml"></div>
        <table class="table table-bordered table-striped"  [innerHTML]="infoProject?.newProject?.sectionOpInvest?.tablePerformance"></table>    
    </div>
</div>

